module.exports = __webpack_public_path__ + "assets/images/layout-banner-right.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/layout-banner-right.svg
// module id = 22
// module chunks = 0